import { Typography } from "@mui/material"
import CustomConfirmDialog from "../../../core/components/common/custom-confirm-dialog.component"
import CustomLoader from "../../../core/components/common/custom-loader.component"
import { useGates } from "../hooks/useGates"
import GateService from "../services/api"
import { useEffect } from "react"

const DeleteGateDialog = ({open, close, currentSelectedGate}) => {

    const {isLoadingDeleteGate, deletedGate, errorDeletedGate, deleteGate} = useGates()

    useEffect(() => {
        if (deletedGate) close()
    }, [JSON.stringify(deletedGate)])

    const handleConfirm = () => {
        console.log("delete gate bbb", currentSelectedGate.gate_uid);
        let gate_uid = currentSelectedGate.gate_uid
        deleteGate(gate_uid)
    }

    return(
        <>
            <CustomConfirmDialog
            loading={isLoadingDeleteGate}
            open={open}
            handleClose={close}
            handleConfirm={handleConfirm} 
            title={"Delete Gate"}
            >
            <div>
                {isLoadingDeleteGate ? (
                    <CustomLoader />
                ):(
                    <Typography>{`Are you sure you want to delete this gate?`}</Typography>
                )}
            </div>
            </CustomConfirmDialog>
        </>
    )
}

export default DeleteGateDialog